import customerServiceSVG from '../../assets/icons/customer-service.svg';
import { CoreIcon } from '../core-icon';

import type { IconProps } from '../core-icon';

export const CustomerServiceIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={customerServiceSVG} {...props} />;
};
